import { FormControl, Select, InputLabel } from "@material-ui/core";
import React from "react";
import { DropDownModel } from "../../../helpers/dropDown";
import { inject, observer } from "mobx-react";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";
import "./dropDown.scss";
import classNames from "classnames";
import Notification from "../notification/notification";
import { ValidatedValue } from "../../../helpers/validator";
import { OwnershipTypeId } from "../../../helpers/ownership";

interface DropDownProps {
  onChange: (newValue: any) => void;
  value: string | ValidatedValue<OwnershipTypeId>;
  items: DropDownModel[];
  uiFlagsStore?: UiFlagsStore;
  topLabel?: string;
  disabled?: boolean;
  errorMessage?: string;
}

export function DropDown(props: DropDownProps) {
  const topLabel = props.topLabel;
  const isValidated = typeof props.value == "object" && props.value != null;
  const validatedValue = props.value as ValidatedValue<OwnershipTypeId>;

  function onChange(event: any) {
    props.onChange(event.target.value);
  }
  return (
    <div className="dropdown-wrapper">
      <FormControl disabled={props.disabled} className={classNames({ "disabled": props.disabled })} error={isValidated && !!validatedValue.errorMessage}>
        {!!topLabel && (
          <InputLabel className="input-label">{topLabel}</InputLabel>
        )}
        <Select value={isValidated ? validatedValue.value : props.value} onChange={onChange} variant="outlined" native 
          className={`dropdown ${props.errorMessage ? "has-error" : ""}`} onBlur={() => { isValidated && (validatedValue).validate(); }}>
          <option value={""}
            className={`${props.uiFlagsStore!.partnerName}_mui-menu-item`}
            disabled hidden>
            {""}
          </option>
          {props.items.map((item) => (
            <option value={item.id} key={item.id}
              className={`${props.uiFlagsStore!.partnerName}_mui-menu-item`}>
              {item.displayName}
            </option>
          ))}
        </Select>
        {isValidated ? validatedValue.errorMessage && <Notification type="error" message={validatedValue.errorMessage}/> : props.errorMessage && <Notification type="error" message={props.errorMessage} />}
      </FormControl>
    </div>
  );
}

export default inject("uiFlagsStore")(observer(DropDown));